module.exports = __webpack_public_path__ + "img/location-deny.c64ff659.jpg";